import { Component } from 'preact';
import styled from 'styled-components';

class Header extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		
		const HeaderContainer = styled.div`
			align-items: center;
			display: flex;
			background: url(${this.context.branding.headerBackground});
			background-position: center center;
			background-repeat: no-repeat;
			background-size: cover;
			flex-direction: column;
			height: calc(100vw * (875 / 1920));
			justify-content: center;
			max-height: 87.5rem;
			@media only screen and (max-width: 1200px) {
				height: 54rem;
				max-height: initial;
			}
			@media only screen and (max-width: 680px) {
				height: 40rem;
			}
			h1 {
				color: ${this.context.colors.link};
				font-family: ${this.context.branding.headerFont};
				font-size: 7.2rem;
				letter-spacing: 0.2rem;
				margin: -10rem 0 0 0;
				text-align: center;
				text-transform: uppercase;
				@media only screen and (max-width: 1200px) {
					font-size: 6rem;
					line-height: 1.25;
				}
				@media only screen and (max-width: 680px) {
					font-size: 3rem;
					margin-bottom: 3rem;
				}
			}
			a {
				background-color: ${this.context.colors.primary};
				color: ${this.context.colors.link};
				font-family: ${this.context.branding.headerFont};
				font-size: 1.4rem;
				font-weight: 600;
				padding: 1.7rem 2.2rem;
				text-decoration: none;
				text-transform: uppercase;
				&:hover {
					background-color: ${this.context.colors.accent};
				}
			}
		`;

		return (
			<HeaderContainer>
				<h1>{this.context.copy.tagLine}</h1>
				<a href={this.context.branding.gameURL} target="_blank">{`Play ${this.context.copy.gameName}`}</a>
			</HeaderContainer>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./components/Header.js